import React from "react";
import { useTranslation } from "react-i18next";
import { useRevalidator, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function SendLetter({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:send_letter", { developer_id: developerId }));
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");
    const revalidator = useRevalidator();
    const { api_post } = useRequest();

    if (!apiData) return;

    const doArchive = (ev) => {
        api_post(ev, url_reverse("api:dashboard:archive"), {
            params: {
                action: ev.target.value,
                entity_id: developerId,
                entity_type: "developer",
            },
            then: (resp) => {
                if (resp.status === "ok") revalidator.revalidate();
            },
        });
    };

    const headerTools = (
        <>
            {developerCommonInfo.in_archive ? (
                <DevForm.Button variant="dark" size="sm" name="archive" value="from" onClick={doArchive}>
                    {t("Достать из архива дашборда")}
                </DevForm.Button>
            ) : (
                <DevForm.Button variant="dark" size="sm" name="archive" value="to" onClick={doArchive}>
                    {t("В архив дашборда")}
                </DevForm.Button>
            )}
        </>
    );

    return (
        <CommonCard header={header} headerTools={headerTools}>
            <FormFieldGroup label={t("Язык ответа от команды VK Play")}>
                <div>{developerCommonInfo.developer.contact_lang}</div>
            </FormFieldGroup>
            <RenderForm submitButtonText={t("Отправить")} />
        </CommonCard>
    );
}
